import "ngstorage";
import auth from "../../services/auth.js";
import events from "../../services/events.js";
import security from "../../services/security.js";
import common from "../../services/common.js";
import profiles from "../../services/profile.js";

class JobblerprofileController {
  constructor(
    $http,
    $localStorage,
    $state,
    AuthService,
    EventsService,
    JobsService,
    $stateParams,
    SecurityService,
    ProfilesService,
    CommonService,
    $rootScope,
    $location,
    $timeout,
    $companies,
    Messagingv2Service,
    $scope
  ) {
    this.name = "jobblerprofile";
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$companies = $companies;
    this.$events = EventsService;
    this.$stateParams = $stateParams;
    this.$security = SecurityService;
    this.$messagingv2 = Messagingv2Service;
    this.$common = CommonService;
    this.$rootScope = $rootScope;
    this.$location = $location;
    this.showGalleryVar = false;
    this.sendingMessage = false;
    this.$timeout = $timeout;
    this.$profiles = ProfilesService;
    this.pages = 0;
    this.$scope = $scope;
    this.$jobs = JobsService;
    this.isTeamsPage = false;
    this.divWidth = "width:750px;";
    this.currentPageNumber = 1;
    this.currentUser = this.$localStorage.logged_user;
    this.remain_loading_count = 0;
    this.teamsArr = "Select a team";

    var _this = this;

    _this.teams = _this.$rootScope.teams;

    if (_this.currentUser.company) {
      _this.paymentInfos = _this.currentUser.company.paymentInfos;
    }

    _this.CloseGalleryReviewListener = _this.$rootScope.$on("CloseGalleryReview", function ($event, params) {
      _this.showGallery();
    });

    _this.GetJobblerDataFromServiceListener = _this.$rootScope.$on("GetJobblerDataFromService", function ($rootscope, params) {
      _this.jobblerData = null;
      if (_this.$location.$$path === "/teams") {
        _this.isTeamsPage = true;
      }
      if (params.type === "hired" || params.jobblerData.modalType === "hired") {
        _this.doNotShowHiredButton = true;
      } else {
        _this.doNotShowHiredButton = false;
      }
      if (params.application) {
        _this.applicationForAccept = params.application;
      }
      _this.getJobblerData(params.jobblerData, params.messaging);
      _this.event = params.event;
      _this.sendingMessage = false;
    });

    _this.GetJobblerDataCachedListener = _this.$rootScope.$on("GetJobblerDataCached", function ($rootscope, params) {
      _this.cachedData = null;
      _this.jobblerData = null;
      _this.cachedData = params.application;
      console.log("_this.cachedData");
      console.dir(_this.cachedData);
      _this.setToggleMenu();
      _this.getTeamsInfo();
    });

    _this.SetShiftToModalListener = _this.$rootScope.$on("SetShiftToModal", function ($rootScope, data) {
      _this.jobblerData = data.applicant;

      if (data.isEdit) {
        _this.editConfirmation(data.currentShift, data.applicant.id);
      } else {
        _this.confirmShift(data.currentShift, data.applicant.id);
      }
    });

    _this.ShowProfileListener = _this.$rootScope.$on("ShowProfile", function () {
      _this.sendingMessage = false;
    });

    _this.CollectCardsForConnectListener = _this.$rootScope.$on("CollectCardsForConnect", function ($rootscope, event) {
      _this.showCompleteMessage = undefined;
      _this.showLoader = undefined;
      _this.successfulPayment = undefined;
      _this.successfulPaymentCheckMark = undefined;
      _this.text = undefined;
      _this.generateCardsArray();
    });

    _this.UpdatedCreditCardConnectionListener = _this.$rootScope.$on("UpdatedCreditCardConnection", function ($rootscope, event) {
      _this.currentUser = _this.$auth.getUserData();
      _this.paymentInfos = _this.currentUser.company.paymentInfos;
      _this.generateCardsArray();
      _this.displayConnectionScreen();
    });

    _this.SetShiftsToModalListener = _this.$rootScope.$on("SetShiftsToModal", function ($rootscope, data) {
      _this.jobblerData = data.app.applicant;
      _this.jobblerData.jobblerId = data.app.applicant.id;
      _this.shifts_for_confirm = data.shifts;
    });

    _this.$scope.$on("$destroy", _this.SetShiftsToModalListener);
    _this.$scope.$on("$destroy", _this.SetShiftToModalListener);
    _this.$scope.$on("$destroy", _this.CloseGalleryReviewListener);
    _this.$scope.$on("$destroy", _this.GetJobblerDataFromServiceListener);
    _this.$scope.$on("$destroy", _this.ShowProfileListener);
    _this.$scope.$on("$destroy", _this.CollectCardsForConnectListener);
    _this.$scope.$on("$destroy", _this.UpdatedCreditCardConnectionListener);
    _this.$scope.$on("$destroy", _this.GetJobblerDataCachedListener);

    this.jobblerData = this.$common.getJobblerData();

    _this.$scope.$on("$locationChangeStart", function (event, next, current) {
      var answer = "";
      if (next.indexOf("/review") > -1 && next.indexOf("id=") < 1) {
        _this.closeModal();
      } else if (next.indexOf("/overview") > -1 && next.indexOf("id=") < 1) {
        _this.closeModal();
      }
    });
  }

  closeModal() {
    var _this = this;

    _this.$timeout(function () {
      $("#modal-view-jobble .public-profile-content .close-out-button button.close").trigger("click");
    });
  }

  clearUser() {
    this.jobblerData = {};
  }

  getJobblerData(jd, toMsg) {
    var _this = this;

    console.log("getJobblerData");
    console.dir(jd);

    if (_this.isTeamsPage) {
      _this.jobblerData = jd;
      _this.$security.getUser(_this.jobblerData.jobblerId).then(function (response) {
        console.log("get user response");
        console.dir(response);
      });
    } else {
      _this.$timeout(function () {
        _this.jobblerData = jd;
        _this.determineImageDimensions();
        _this.fancyLoadProfile();
        _this.getUserWorkHistory(jd.jobblerId);
      });
    }
  }

  fancyLoadProfile() {
    this.$timeout(() => {
      $("#modal-view-jobble .modal-body.jobber-profile-info").slideDown(300);
    }, 400);
  }

  getUserWorkHistory(userId) {
    this.setLoader();
    this.$security.getUserLatestWorkHistory(userId).then(
      (response) => {
        if (response.data.success === "false") {
          console.error("No work history permissions.");
          this.unSetLoader();
        } else {
          this.formatWorkHistory(response.data);
        }
      },
      (error) => {
        alert("There was an error retrieving users work history. Please contact support.");
        this.unSetLoader();
      }
    );
  }

  setToggleMenu() {
    this.$timeout(() => {
      $(".bg-check-status-image").tooltip({});
    }, 1000);
  }

  formatWorkHistory(histories) {
    let workHistory = [];

    histories.data.forEach((history) => {
      console.log("each history");
      console.dir(history);
      let shiftCount;
      if (history.totalNumberOfPaidShifts >= 2) {
        shiftCount = "s";
      } else {
        shiftCount = "";
      }

      let date = moment(history.latestPaidShiftDate).format("YYYY");
      let entry =
        history.totalNumberOfPaidShifts + " " + history.latestJobbleType + " shift" + shiftCount + " for " + history.companyName + " in " + date;
      workHistory.push(entry);
    });

    this.workHistory = workHistory;
    this.unSetLoader();
  }

  figurePagintion(totalRatings) {
    var _this = this;

    let pageArray = [];
    let numberOfRatings = Math.ceil(totalRatings / 5);

    if (numberOfRatings > 0) {
      for (var i = 0; i < numberOfRatings; i++) {
        pageArray.push(i + 1);
        _this.pages = pageArray;
      }
    } else {
      _this.pages = [];
    }
  }

  showGallery() {
    var _this = this;

    if (_this.jobblerData) {
      if (_this.showGalleryVar) {
        _this.showGalleryVar = false;
        _this.$timeout(function () {
          jQuery("#modal-view-jobble").modal();
        }, 300);
      } else {
        _this.$timeout(function () {
          jQuery("#modal-view-jobble").modal("toggle");
        }, 200);
        _this.$timeout(function () {
          jQuery("#modal-view-jobble").modal();
          _this.showGalleryVar = true;
        }, 1000);
        _this.$timeout(function () {
          _this.$rootScope.$emit("CollectPhotos", {
            dataprof: _this.jobblerData.pics,
          });
        }, 1400);
      }
    }
  }

  next() {
    for (var i = 0; i < this.jobblerData.pics.length; i++) {
      if (this.jobblerData.pics[i] === this.jobblerData.currentPicture) {
        if (i === this.jobblerData.pics.length - 1) {
          this.jobblerData.currentPicture = this.jobblerData.pics[0];
        } else {
          this.jobblerData.currentPicture = this.jobblerData.pics[i + 1];
        }
        break;
      }
    }
  }

  back() {
    for (var i = 0; i < this.jobblerData.pics.length; i++) {
      if (this.jobblerData.pics[i] === this.jobblerData.currentPicture) {
        if (i === 0) {
          this.jobblerData.currentPicture = this.jobblerData.pics[this.jobblerData.pics.length - 1];
        } else {
          this.jobblerData.currentPicture = this.jobblerData.pics[i - 1];
        }
        break;
      }
    }
  }

  triggerConfirmationModal(application) {
    var _this = this;

    _this.setLoader();

    _this.getJobblesAndShifts(application);

    _this.$timeout(function () {
      $("#modal-view-jobble").modal("toggle");
    });

    _this.$timeout(function () {
      $("#modal-confirm-jobbler").modal();
    }, 300);

    _this.$timeout(function () {
      $("#modal-confirm-jobbler").modal();
    }, 1000);
  }

  getJobblesAndShifts(app) {
    var _this = this;

    _this.$jobs.getJobbleWithShifts(app.jobbleId).then(
      function (response) {
        _this.format_time_zones(response.data.shifts);

        _this.unSetLoader();
      },
      function (error) {
        console.log("in error");
        console.dir(error);
      }
    );
  }

  format_time_zones(shifts) {
    var _this = this;

    try {
      shifts.forEach(function (shift) {
        shift.startTimeFormatted = moment(shift.timeInterval.startTime).tz(shift.contactInfo.place.timeZoneId).format("MM/DD/YYYY hh:mm A");
        shift.endTimeFormatted = moment(shift.timeInterval.endTime).tz(shift.contactInfo.place.timeZoneId).format("MM/DD/YYYY hh:mm A");
        if (shift.confirmationDateTime) {
          shift.confirmationDateTimeFormatted = moment(shift.confirmationDateTime)
            .tz(shift.contactInfo.place.timeZoneId)
            .format("MM/DD/YYYY hh:mm A");
        }
        if (shift.confirmationResponse === true) {
          shift.confirmationResponseDisplay = "Yes";
        } else {
          shift.confirmationResponseDisplay = "No";
        }
      });
    } catch (err) {
    } finally {
      shifts.sort(function (a, b) {
        return new Date(a.timeInterval.startTime).getTime() - new Date(b.timeInterval.startTime).getTime();
      });

      _this.shifts_for_confirm = shifts;
    }
  }

  unConfirmShift(shift, id) {
    var _this = this;

    _this.confirmationNote = null;

    if (id) {
      shift.userId = id;
    } else {
      shift.userId = _this.jobblerData.jobblerId;
    }

    _this.shift_confirm = shift;

    if (id) {
      _this.$timeout(function () {
        $("#modal-confirm-jobbler-note").modal();
      });
    } else {
      _this.$timeout(function () {
        $("#modal-confirm-jobbler").modal("toggle");
      });
      _this.$timeout(function () {
        $("#modal-un-confirm-jobbler-note").modal();
      }, 300);
    }
  }

  confirmShift(shift, id) {
    var _this = this;

    _this.confirmationNote = null;

    if (id) {
      shift.userId = id;
    } else {
      shift.userId = _this.jobblerData.jobblerId;
    }

    _this.shift_confirm = shift;

    if (id) {
      _this.$timeout(function () {
        $("#modal-confirm-jobbler-note").modal();
      });
    } else {
      _this.$timeout(function () {
        $("#modal-confirm-jobbler").modal("toggle");
      });
      _this.$timeout(function () {
        $("#modal-confirm-jobbler-note").modal();
      }, 300);
    }
  }

  clearData() {
    this.$timeout(() => {
      $("#modal-view-jobble .modal-body.jobber-profile-info").hide();
      this.jobblerData = undefined;
      this.cachedData = undefined;
      this.workHistory = undefined;
    }, 200);
  }

  sendConfirmationData(type) {
    var _this = this;

    let shift = _this.shift_confirm;
    let user_to_update = _this.jobblerData;

    shift.note = _this.confirmationNote;

    console.log("what is the shift");
    console.dir(shift);

    if (!shift.jobbler) {
      console.log("do we come here");
      shift.userId = _this.jobblerData.jobblerId;
    }

    if (type === 2) {
      _this.$jobs.updateShiftWithUnConfirmationData(shift).then(
        function (response) {
          let timestamp = response.data.timestamp;

          _this.$timeout(function () {
            _this.$rootScope.$emit("UpdateRosterPageWithConfirmationData", {
              user_to_update,
              shift,
              timestamp,
              type,
            });
          });

          _this.$timeout(function () {
            $("#modal-un-confirm-jobbler-note").modal("toggle");
            _this.unSetLoader();
          }, 300);
        },
        function (error) {
          alert("Error");
          console.log("in error");
          console.dir(error);
        }
      );
    } else {
      _this.$jobs.updateShiftWithConfirmationData(shift).then(
        function (response) {
          console.log("response");
          console.dir(response);
          let timestamp = response.data.timestamp;

          _this.$timeout(function () {
            _this.$rootScope.$emit("UpdateRosterPageWithConfirmationData", {
              user_to_update,
              shift,
              timestamp,
            });
          });

          _this.$timeout(function () {
            $("#modal-confirm-jobbler-note").modal("toggle");
            _this.unSetLoader();
          }, 300);
        },
        function (error) {
          alert("Error");
          console.log("in error");
          console.dir(error);
        }
      );
    }
  }

  setLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").removeClass("wait");
    });
  }

  triggerTeamModal(user) {
    var _this = this;

    _this.successAddingToTeam = null;

    _this.$timeout(function () {
      $("#modal-view-jobble").modal("toggle");
    });

    _this.disable_team_button = true;
    _this.placeholder = 0;

    _this.options = {
      values: [],
    };

    _this.$companies.getTeamsUltraTrim().then(
      function (response) {
        let teams = [];

        let placeholder = {id: 0, name: "Select Team"};

        teams.push(placeholder);
        teams = teams.concat(response.data);

        _this.options.values = teams;

        _this.$timeout(function () {
          $("#modal-add-user-to-team").modal();
        }, 200);
      },
      function (error) {
        console.log("in teams error");
        console.dir(error);
      }
    );
  }

  getTeamsInfo() {
    var _this = this;

    _this.moreThanOneTeam = false;

    _this.$companies.getTeamsUltraTrim().then(
      function (response) {
        console.log("response from teams count");
        console.dir(response);
        if (response.data.length > 0) {
          _this.moreThanOneTeam = true;
        }
      },
      function (error) {
        console.log("in teams error");
        console.dir(error);
      }
    );
  }

  setTeamsForModal(teams) {
    var _this = this;

    console.log("set teams for modal");
    console.dir(teams);
    //_this.id_arry_for_backend.push()
  }

  teamsChanged() {
    var _this = this;

    console.log("teams changed");
    console.dir(_this.placeholder);

    if (_this.placeholder !== 0) {
      _this.disable_team_button = false;
    }
  }

  addUserToTeam() {
    var _this = this;

    let id = _this.placeholder;
    let email = _this.jobblerData.email;

    _this.disable_team_button = true;

    _this.$companies.updateCloudWithNewUser(id, email).then(
      function (response) {
        _this.$timeout(function () {
          console.log("what is the result");
          console.dir(response.data.result);

          if (response.data.status === "OK") {
            console.log("in the true");
            _this.successAddingToTeam = true;
          } else {
            console.log("in the false");
            _this.successAddingToTeam = false;
          }

          _this.disable_team_button = false;
        }, 300);

        _this.$timeout(function () {
          _this.successAddingToTeam = null;
          $("#modal-add-user-to-team").modal("toggle");
        }, 4000);
      },
      function (error) {}
    );
  }

  confirmAdd() {
    var _this = this;
    _this.remain_loading_count--;

    _this.$companies.updateCloudWithNewUser(_this.teamsArr.id, _this.jobblerData.email).then(function (data) {
      _this.$timeout(function () {
        jQuery("#modal-add-user-to-team-modal .modal-header button.close").trigger("click");
      }, 200);

      _this.$timeout(function () {
        jQuery("#modal-add-user-to-team-confirm").trigger("click");
        _this.remain_loading_count++;
      }, 2000);
    });
  }

  addTeamToList(team) {
    var _this = this;
  }

  messageJobbler(jobbler) {
    var _this = this;

    _this.sendingMessage = true;
    let scp = _this.$scope;
    let msg = _this.$messagingv2;
    _this.$timeout(function () {
      _this.$rootScope.$emit("SetJobblerForMessage", {
        jobbler: jobbler,
        event: _this.event,
        s: scp,
        m: msg,
      });
    });
  }

  paginateRatings(page) {
    var _this = this;
    _this.currentPageNumber = page;
    var offset = page * 5 - 5;
    var id = _this.jobblerData.jobblerId;
    _this.$auth.getRatings(offset, id).then(function (response) {
      if (response.statusText === "OK" || response.status === 200) {
        var ratings = response.data.ratings;
        if (ratings.length > 0) {
          _this.handle_ratings(ratings);
        }
      } else {
        alert("There was an error loading the ratings for this user. Please contact support.");
      }
    });
  }

  handle_ratings(ratings) {
    var _this = this;
    try {
      ratings.forEach(function (rating) {
        rating.lastUpdatedLocalTime = _this.getClientDate(rating.lastUpdated);
      });
    } finally {
      _this.$timeout(function () {
        _this.jobblerData.ratings = ratings;
      });
    }
  }

  getClientDate(serverUTCTime) {
    var date = new Date(serverUTCTime);
    //return moment(date).format("MMM DD, YYYY");
    return moment(date).format("LLLL");
  }

  connectJobbler(applicant) {
    var _this = this;

    if (_this.paymentInfos.length == 0) {
      _this.$timeout(function () {
        jQuery("#modal-view-jobble .modal-header button.close").trigger("click");
      });

      _this.$timeout(function () {
        jQuery("#link-modal-add-card").trigger("click");
      }, 300);

      return;
    }

    _this.$timeout(function () {
      jQuery("#modal-view-jobble .modal-header button.close").trigger("click");
    });

    _this.$timeout(function () {
      jQuery("#modal-connect-jobbler-click").trigger("click");
      //_this.testy = "true";
      //_this.cardHasNotBeenSelectedForConnect = true;
    }, 350);

    //_this.creditCardsForCompany = _this.currentUser.company.paymentInfos;

    _this.generateCardsArray();
  }

  generateCardsArray() {
    var _this = this;

    var credCardArray = [];
    var last4Array = [];
    console.log("in generate");
    console.dir(_this.paymentInfos);
    console.dir(_this.$rootScope);

    try {
      _this.paymentInfos.forEach(function (card) {
        if (card.bankName && card.validated) {
          card.last4edited = "******-" + card.last4;
          last4Array.push(card.last4edited);
        } else {
          card.last4edited = "****-****-****-" + card.last4;
          last4Array.push(card.last4edited);
        }
      });
    } finally {
      last4Array.unshift("Payment method");

      if (_this.$rootScope.defaultCard) {
        _this.creditCardsForCompany = {
          value: _this.$rootScope.defaultCard.last4edited,
          values: last4Array,
        };
      } else {
        _this.creditCardsForCompany = {
          value: "Payment method",
          values: last4Array,
        };
      }

      console.log("_this.creditCardsForCompany");
      console.dir(_this.creditCardsForCompany);
    }
  }

  connectJobblerConfirm(valid) {
    var _this = this;

    _this.$timeout(function () {
      _this.showLoader = true;
      jQuery("#modal-connect-jobbler .important-modal-text").hide("slow");
    });

    try {
      if (!_this.$rootScope.defaultCard || _this.creditCardsForCompany.value !== _this.$rootScope.defaultCard.last4edited) {
        for (var i = 0; i < _this.paymentInfos.length; i++) {
          if (_this.paymentInfos[i].last4edited === _this.creditCardsForCompany.value) {
            _this.$rootScope.defaultCard = _this.paymentInfos[i];
          }
        }
      }
    } finally {
      _this.$security.bulkConnect(_this.$rootScope.defaultCard, _this.jobblerData).then(function (response) {
        console.log("response...");
        console.dir(response);

        var errorFound = false;

        try {
          for (var i = 0; i < response.data.length; i++) {
            console.log("*********************************************each response");
            console.dir(response.data);
            if (response.data[i].status === "error") {
              alert("There was an error while trying to make a connection: " + response.data[i].message);
              errorFound = true;
            }
          }
        } finally {
          if (response.statusText === "OK" && !errorFound) {
            if (response.data[0].status === "error") {
              alert("this jobbler is already booked for time frame");
            } else {
              _this.$rootScope.$broadcast("AdjustApplicantsAfterConnection", {
                acceptedJobbler: _this.jobblerData,
              });

              _this.$timeout(function () {
                _this.successfulPayment = true;
                jQuery("#modal-connect-jobbler .image-to-hide").hide("slow");
              }, 2000);

              _this.$timeout(function () {
                _this.successfulPaymentCheckMark = true;
              }, 2500);
            }
          } else {
            _this.$timeout(function () {
              jQuery("#modal-connect-jobbler-click").trigger("click");
            }, 300);
          }
        }
      });
    }
  }

  rejectJobbler(jobbler) {
    var _this = this;
    console.log("rejectJobbler");
    console.dir(this.jobblerData);
    let data = {};
    data.jobbler = _this.jobblerData;
    data.status = 2;
    //in eventreview applicants ... rootScope call this function
    //confirmRemoveJobbler
    _this.$timeout(function () {
      _this.$rootScope.$emit("RejectFromProfileScreen", data);
    });
  }

  hireJobblers(jobbler) {
    var _this = this;

    console.log("who is the jobbler");
    console.dir(jobbler);

    var jobblesAndApplicants = [];
    var jobbleObjForApplication = {};

    jobbleObjForApplication.applicant = jobbler.jobblerId;
    jobbleObjForApplication.jobble = jobbler.jobbleId;
    jobbleObjForApplication.index = 0;
    jobblesAndApplicants.push(jobbleObjForApplication);

    _this.$security.hireJobblerAfterConnection(jobblesAndApplicants).then(
      function (response) {
        console.log("response from bulk accepted");
        console.dir(response);

        if (response.data[0].status === "error") {
          alert("Error connecting with this jobbler. Please contact admin for support.");
          return;
        }

        _this.$rootScope.$broadcast("AdjustApplicantsAfterConnection", {
          acceptedJobbler: jobbler,
        });
      },
      function (response) {
        _this.$timeout(function () {
          jQuery("#show-application-alert").trigger("click");
        }, 100);
      }
    );
  }

  hireJobbler() {
    var _this = this;
    console.log("hire jobbler");
    console.dir(_this.jobblerData);
    console.dir(_this.applicationForAccept);
    _this.$timeout(function () {
      _this.$rootScope.$emit("HireJobblerFromProfile", {
        application: _this.applicationForAccept,
      });
    });
  }

  sendMessageForConnection(text) {
    var _this = this;
    var usersObj = {};
    usersObj.users = _this.currentUser.email + ", " + _this.jobblerData.email;
    usersObj.event = _this.$stateParams.eventId;
    _this.$timeout(function () {
      jQuery("#modal-connect-jobbler .fade-in-loader").hide("slow");
    });
    _this.$timeout(function () {
      jQuery("#modal-connect-jobbler .image-to-hide").show("slow");
    }, 400);
    _this.$messagingv2.createOrReturnChannelTrimmed(usersObj).then(function (response) {
      var channelWeWant = response.data.result[0].channelName;
      _this.findChannel(channelWeWant, text);
    });
  }

  findChannel(channel, text) {
    console.log("text?");
    console.dir(text);
    var _this = this;
    if (_this.$rootScope.allChannelNames) {
      if (_this.$rootScope.allChannelNames.indexOf(channel) > -1) {
        console.log("we found the channel.....zzzzzzzzzzzzzzzzzzzzzzzzzzzz");

        var jobblerArray = [];
        jobblerArray.push(_this.jobbler);
        _this.blockedList = _this.$messagingv2.generateBlockList(jobblerArray);
        var isNewChannel = false;
        var indexOf = _this.$rootScope.allChannelNames.indexOf(channel);
        _this.$messagingv2.publishMessage(text, null, null, null, _this.blockedList, _this.event.id, null, isNewChannel, channel, indexOf);

        /*
			  _this.$rootScope.channels[i].channelArrayHolder[x].isActive = 'active';
			  _this.$rootScope.activeChannel = _this.$rootScope.channels[i].channelArrayHolder[x].name;
			  channelThatWasFound = _this.$rootScope.channels[i].channelArrayHolder[x];
			  */
        //console.log('...................the channel was found........................');
        //channelWasFound = true;
        _this.remain_loading_count = 0;
      } else {
        _this.loadChannelsNew(channel, text);
      }
    } else {
      _this.loadChannelsNew(channel, text);
    }
  }

  loadChannelsNew(channel, text) {
    console.log("loadChannelsNew");
    console.dir(text);

    var _this = this;

    console.log("might not need to call load channels because its already being done for channels that dont exist");
    console.dir(channel);

    var usersloop = function (value) {
      _this.$timeout(function () {
        if (value > 0) {
          _this.$messagingv2.getChannels(1).then(
            function (response) {
              console.log("-------------these need to match response from load channels-----------------------------------");
              console.dir(response);
              console.dir(response.data.channels[0].name);
              console.dir(channel);
              if (response.data.channels[0].name === channel) {
                console.log("we have a match....heres the channel lets add it to the list of channels we already have");
                console.dir(response.data.channels[0]);
                console.dir(_this.message);
                console.log("text");
                console.dir(text);
                var jobblerArray = [];
                jobblerArray.push(_this.jobbler);
                _this.blockedList = _this.$messagingv2.generateBlockList(jobblerArray);
                console.log("block list?");
                console.dir(_this.blockList);
                var isNewChannel = true;
                var indexOf = null;
                var t = "null";
                if (text) {
                  t = text;
                } else {
                  t = _this.message;
                }

                _this.$timeout(function () {
                  _this.$messagingv2.publishMessage(
                    t,
                    null,
                    null,
                    null,
                    _this.blockedList,
                    _this.eventId,
                    response.data.channels[0],
                    isNewChannel,
                    response.data.channels[0].name,
                    indexOf
                  );
                  jQuery("#modal-connect-jobbler .image-to-hide").hide("slow");
                }, 1000);

                _this.$timeout(function () {
                  _this.showCompleteMessage = true;
                }, 1500);
              } else {
                usersloop(value - 1);
              }
            },
            function (error) {
              console.log("in error in send message");
            }
          );
        } else {
          console.log("at the end...");
        }
      }, 1000);
    };

    usersloop(5);
  }

  displayConnectionScreen() {
    var _this = this;

    _this.$timeout(function () {
      jQuery("#modal-connect-jobbler-click").trigger("click");
    }, 600);
  }

  addAnotherCard() {
    var _this = this;

    console.log("what is the jobbler data at this point");
    console.dir(_this.jobblerData);

    _this.$timeout(function () {
      jQuery("#modal-connect-jobbler .modal-header button.close").trigger("click");
    });

    _this.$timeout(function () {
      jQuery("#link-modal-add-card").trigger("click");
    }, 300);
  }

  closeConnectionWindow() {
    console.log("closeConnectionWindow");

    var _this = this;

    //_this.jobblerData = undefined;
    _this.showCompleteMessage = undefined;
    _this.showLoader = undefined;
    _this.successfulPayment = undefined;
    _this.successfulPaymentCheckMark = undefined;
    _this.text = undefined;
  }

  goToInbox() {
    var _this = this;

    _this.$timeout(function () {
      jQuery("#modal-connect-jobbler .modal-header button.close").trigger("click");
    });

    _this.$timeout(function () {
      _this.$state.go("inbox");
    }, 300);
  }

  cardChanging() {
    console.log("cardChanging");
    console.dir(this.creditCardsForCompany.value);
  }

  previousProfile() {
    var _this = this;
    console.log("previous profile");
    console.dir(_this.jobblerData);

    _this.jobblerData.direction = "previous";

    _this.$timeout(function () {
      _this.$rootScope.$emit("PaginateApplications", {
        data: _this.jobblerData,
      });
    });
  }

  nextProfile() {
    var _this = this;

    _this.jobblerData.direction = "next";

    _this.$timeout(function () {
      _this.$rootScope.$emit("PaginateApplications", {
        data: _this.jobblerData,
      });
    });
  }

  setMessagingBox() {
    var _this = this;
    console.log("setMessagingBox");
    _this.messageJobbler(_this.jobblerData);
  }

  editConfirmation(shift, user, closeShiftModal) {
    var _this = this;

    console.log("editConfirmation");
    console.dir(shift);
    console.dir(user);

    if (closeShiftModal) {
      _this.$timeout(function () {
        $("#modal-confirm-jobbler").modal("toggle");
      });
    }

    shift.userId = _this.jobblerData.jobblerId;
    _this.shift_confirm = shift;

    let user_to_update = _this.jobblerData;

    _this.$timeout(function () {
      $("#modal-confirm-jobbler-note").modal();
    }, 300);

    _this.$jobs.getShift(shift.id).then(
      function (response) {
        console.log("response");
        console.dir(response);
        _this.confirmationNote = response.data.confirmationNote;
      },
      function (error) {
        console.log("error");
        console.dir(error);
      }
    );
  }

  determineImageDimensions() {
    let myImg;
    let imageClassForDisplay;
    this.$timeout(() => {
      myImg = document.querySelector("#jobbler-profile-picture-modal");

      if (myImg) {
        imageClassForDisplay = this.$profiles.dimensionsCalc(myImg.clientHeight, myImg.clientWidth);

        if (imageClassForDisplay === "remove-class") {
          $("#jobbler-profile-picture-modal").removeClass("default");
          $("#jobbler-profile-picture-modal").removeClass("default-long");
        } else {
          $("#jobbler-profile-picture-modal").addClass(imageClassForDisplay);
        }
      }
    });
  }
}

JobblerprofileController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "auth",
  "events",
  "jobs",
  "$stateParams",
  "security",
  "profile",
  "common",
  "$rootScope",
  "$location",
  "$timeout",
  "companies",
  "messagingv2",
  "$scope",
];

export default JobblerprofileController;



// WEBPACK FOOTER //
// ./client/app/common/jobblerprofile/jobblerprofile.controller.js